import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { Bot, ArrowRight } from "lucide-react";
import { track } from "@/lib/forms";

type Props = { source: string; className?: string };

const AlfredCallout = forwardRef<HTMLElement, Props>(({ source, className = "" }, ref) => {
  return (
    <section ref={ref} className={`section-pad bg-lightblue ${className}`}>
      <div className="container-atk">
        <div className="card-atk flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-start gap-4">
            <div className="h-11 w-11 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Bot className="h-5 w-5 text-primary" />
            </div>
            <div>
              <h3 className="text-[18px] sm:text-[20px] font-bold text-navy leading-tight">
                Not sure what to automate?
              </h3>
              <p className="mt-1 text-[14.5px] text-muted-foreground max-w-md leading-relaxed">
                Meet Alfred, the plain-English workflow guide.
              </p>
            </div>
          </div>
          <Link
            to="/alfred"
            onClick={() => track("cta_alfred_callout_click", { source })}
            className="text-cta flex-shrink-0"
            data-link="meet-alfred"
          >
            Meet Alfred <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
});
AlfredCallout.displayName = "AlfredCallout";
export default AlfredCallout;
